<div>
  @if (categories$ | async; as categories) {
    <store-storefront
      [categories]="categories"
      [categoryIdToStoreItemListMap]="storeItemsMap$ | async"
      [useCustomCase]="true"
      (productSelected)="onProductSelected($event)"
      (getDataForCategory)="onNeedDataForCategory($event)"
      [showAllPrices]="true"
      [filtersDisabled]="true"
      [currencyCode]="currency$ | async"
    ></store-storefront>
  } @else {
    <div>
      <div style="margin-top: 48px">
        <div style="margin-bottom: 20px">
          <store-search-bar-stencil></store-search-bar-stencil>
        </div>
        <store-card-stencil-list [numCards]="12"></store-card-stencil-list>
      </div>
    </div>
  }
</div>
